import { useState } from "react";

export function useForm<T extends Record<string, unknown>>(initial: T) {
  const [values, setValues] = useState<T>(initial);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  function update<K extends keyof T>(field: K, value: T[K]) {
    setValues((v) => ({ ...v, [field]: value }));
  }

  async function submit(action: () => Promise<void>): Promise<boolean> {
    setError(null);
    setLoading(true);
    try {
      await action();
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Erreur inconnue");
      return false;
    } finally {
      setLoading(false);
    }
  }

  return { values, update, error, setError, loading, submit };
}
